// Firebase Configuration for Web App
// Realtime Database URL is not included in the Firebase web snippet, so it can
// be overridden with REACT_APP_FIREBASE_DATABASE_URL if your database is regional.

const defaultDatabaseURL = "https://swatin-be192-default-rtdb.firebaseio.com";

export const FirebaseConfig = {
  apiKey: "AIzaSyDvEqOBp2cUu4FbQQz6_3OkzF9fJNOl1qs",
  authDomain: "swatin-be192.firebaseapp.com",
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || defaultDatabaseURL,
  projectId: "swatin-be192",
  storageBucket: "swatin-be192.firebasestorage.app",
  messagingSenderId: "89077003268",
  appId: "1:89077003268:web:32f88c23aee3cccce47151",
  measurementId: "G-0T15GVJ8BE",
};

export default FirebaseConfig;
